import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { StepRecomPicture } from '../interface/step-recom-picture';

@Injectable({
  providedIn: 'root'
})
export class StepRecomPictureService {

  private apiUrl = environment.apiRoot + '/steprecompicture';

  constructor(private http: HttpClient) { }

  getAllPicturesOfStepRecom(stepRecomId: number): Observable<StepRecomPicture[]> {
    return this.http.get<StepRecomPicture[]>(this.apiUrl + '/allofsteprecom?StepRecomId=' + stepRecomId);
  }

  getStepRecomPicture(StepRecomPictureId: number): Observable<ArrayBuffer> {
    return this.http.get(this.apiUrl + '/picture?StepRecomPictureId=' + StepRecomPictureId, { responseType: 'arraybuffer' });
  }

  fileUpload(StepRecomId: number, file: File): Observable<any> {
    const formData = new FormData();
    formData.append("file", file);
    return this.http.post(this.apiUrl + '/fileupload?StepRecomId=' + StepRecomId, formData);
  }

  deleteStepRecomPicture(StepRecomPictureId: number): Observable<string> {
    return this.http.delete<string>(this.apiUrl + '/delete?StepRecomPictureId=' + StepRecomPictureId);
  }

}
